import * as React from 'react'
import StepTitle from '../../common/components/step-title'
import SubHeader from '../../common/components/sub-header'
import Button from '../../common/components/button'
import { withValidation } from '../../common/modules/validation'
import { withForm } from '../../common/modules/form'
import { withStatus } from '../../common/modules/status'
import { withSubmission } from '../../common/modules/submission'
import { withNavigation } from '../../common/modules/navigation'
import { withRouteBlocker } from '../../common/modules/route-blocker'
import { withFields } from '../../common/modules/fields'
import { withProductData } from '../../common/modules/product-data'
import { withScrollToTop } from '../../common/modules/scroll-to-top'
import InputField from "../../common/components/input-field";


export const formConfig = state => {
    const productData = state.productData;
    const fields = state.fields;

    return {
        /* Although is not recommended, the properties must be in double quotes
               to go around the already built validation of properties to send in requests.
         */
        rules: {
            "arpcMitigation.arpcRoofMitCode": [],
            "arpcMitigation.arpcGarageMitCode": [],
            "arpcMitigation.arpcWindowMitCode": [],
            "arpcMitigation.arpcDoorMitCode": [],
            "arpcMitigation.arpcGutterMitCode": []
        },
        predicates:{},
        options:{
            "arpcMitigation.arpcRoofMitCode":  function(){
              return productData.productOptions.ARPC_ROOF_MIT.filter(e =>  filterAllowedRoofOptions(fields).indexOf(e.value) > -1);
            }(),
            "arpcMitigation.arpcGarageMitCode": productData.productOptions.ARPC_GARAGE_MIT,
            "arpcMitigation.arpcWindowMitCode": productData.productOptions.ARPC_WINDOW_MIT,
            "arpcMitigation.arpcDoorMitCode": productData.productOptions.ARPC_DOOR_MIT,
            "arpcMitigation.arpcGutterMitCode": productData.productOptions.ARPC_GUTTER_MIT
        },
        inferred:{},
        transformOut: data => data,
    }
}

export const filterAllowedRoofOptions = (fields): String[] => {
    const yearBuilt = fields.yearBuilt;
    const roofConstruction = fields.roofConstruction;
    const tilesOptions = ['TILES_TERRACOTTA', 'TILES_SHINGLE', 'CEMENT'];
    const metalOptions = ['ALUMINIUM_ZINC_IRON_STEEL', 'TILES_COPPER'];

    let allowedValues = [];
    if (tilesOptions.concat(metalOptions).indexOf(roofConstruction) > -1) {
        if (tilesOptions.indexOf(roofConstruction) > -1 && yearBuilt < 1982) {
            allowedValues = ['STRATA_G01', 'STRATA_G02', 'STRATA_G03', 'STRATA_G04', 'STRATA_G07'];
        }
        if (tilesOptions.indexOf(roofConstruction) > -1 && yearBuilt >= 1982) {
            allowedValues = ['STRATA_G01', 'STRATA_G03', 'STRATA_G07'];
        }
        if (metalOptions.indexOf(roofConstruction) > -1 && yearBuilt < 1982) {
            allowedValues = ['STRATA_G01', 'STRATA_G02', 'STRATA_G05', 'STRATA_G06', 'STRATA_G07'];
        }
        if (metalOptions.indexOf(roofConstruction) > -1 && yearBuilt >= 1982) {
            allowedValues = ['STRATA_G01', 'STRATA_G05', 'STRATA_G07'];
        }
    }
    return allowedValues;
}

@withSubmission
@withNavigation
@withProductData
@withValidation
@withRouteBlocker
@withFields
@withScrollToTop
@withStatus
@withForm(formConfig)
export default class extends React.Component<any, any> {

    componentWillMount(){
        const path = window.location.href;
        if(this.props.fields.referred){
            const newPath = path+'?status=Referred'
            window.location.replace(newPath);
        }
        else if(this.props.fields.showPrice){
            const newPath = path + '?status=Quoted'
            window.location.replace(newPath);
        }
        else if(this.props.fields.indicativePrice){
            const newPath = path + '?status=IndicativePrice'
            window.location.replace(newPath);
        }

        
        if(this.props.fields.declined || this.props.fields.referred){
            this.props.actions.navigation.setCloseWarning(false);
            this.props.actions.navigation.disableRoutes([
                "/step-1",
                "/step-2",
                "/step-3",
                "/step-4",
                "/step-5"
            ])
        }

        if(this.props.fields.declined){
            this.props.actions.navigation.changeRoute("/declined");
        }

    }

    render() {
        const fields = this.props.fields;
        const allowedOptions = filterAllowedRoofOptions(fields);

        return (
            <div className="row">
                <StepTitle>ARPC Mitigation Questions</StepTitle>

                <SubHeader>Answering the following questions about your property may provide some premium relief depending on your mitigation measures. Please see <a href="https://chu.com.au/cyclone-mitigation/" target="_blank">link</a> for more details</SubHeader>

                {(allowedOptions.length > 0 ) &&
                    <InputField   field="arpcMitigation.arpcRoofMitCode" type="String" label="Please select the most appropriate mitigation method for the roof construction for all Buildings at your Plan:"                                                                                        inline={true}  />
                }
                <InputField    field="arpcMitigation.arpcWindowMitCode" type="String" label="Does the Building have Permanent protection (such as cyclone wind-rate shutters or cyclone debris-rated screens) installed externally on all glass windows?"                                               inline={true}  />
                <InputField    field="arpcMitigation.arpcDoorMitCode" type="String" label="Are all external doors on all Strata Buildings: Metal OR Timber with solid cores OR Glass doors (including balcony doors) with debris-rated impact screens or wind-rated shutters?"                        inline={true}  />
                {((!!fields.yearBuilt && fields.yearBuilt < 2012) || (!!fields.numberOfFloors && fields.numberOfFloors <= 3)) &&
                        <InputField    field="arpcMitigation.arpcGarageMitCode" type="String" label="Is the Garage Door located in the Main structure/Building and has been installed to be compliant with AS4505 (version 2012 or later)?"                                                             inline={true}  />
                }
                <InputField    field="arpcMitigation.arpcGutterMitCode" type="String" label="Are all gutters on all Buildings compliant with the following conditions: Gutter overflows for all perimeter gutters on boxed eaves and/or all box gutters (at each end) OR All eaves have no eave lining" inline={true}  />

                <Button.Container>
                    <Button.Back route="/step-5" /> <Button.Continue onClick={ this.onContinue.bind(this) }/>
                </Button.Container>
            </div>
        )
    }

    onContinue(){
        const endpoint = this.props.submission.endpoints.flatQuote;
        this.props.actions.submission.submit(endpoint, this.proceed.bind(this), [
            require("./step-1").formConfig,
            require("./step-2").formConfig,
            require("./step-3").formConfig,
            require("./step-4").formConfig,
            require("./step-5").formConfig,
            require("./step-8").formConfig
        ])
    }

    proceed(){
        this.props.actions.navigation.changeRoute("/step-6");
    }
}




// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/strata/routes/step-8.tsx